import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link as Goto } from 'react-router-dom';
import styled from 'styled-components';
import Link from 'valuelink';
import { Input } from 'valuelink/tags';

import { verifyOtp, login } from '../../actions/index';
import {
  BoldText,
  RegularText,
  SemiBoldText,
} from '../../components/common/Text';
import { FadeInTransition } from '../../components/transitions/transitions';
import { PrimaryButton } from '../../components/common/Buttons';
import greenTick from '../../images/onboarding/greenTick.svg';
import rightGraphic from '../../images/onboarding/onboarding-graphic-right.svg';
import leftGraphic from '../../images/onboarding/onboarding-graphic-left.svg';
import { logEvent } from '../../utils/logEvent';
import { ReactComponent as WhatsAppIcon } from "../../images/common/Whatsapp.svg"
import { ReactComponent as SmsIcon } from "../../images/common/sms.svg"

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 3rem 1.25rem;
  background: #ffffff;
  position: relative;
  overflow-y: scroll;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-self: stretch;
  align-items: flex-start;
`;

const ScreenIcon = styled.img`
  max-width: 4.265rem;
`;

const TitleText = styled(BoldText)`
  font-size: ${() => `${1.5 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  align-self: flex-start;
  text-align: left;
  line-height: 36px;
  margin-bottom: 10px;
`;

const SubtitleText = styled(RegularText)`
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  align-self: flex-start;
  text-align: left;
  color: #76738c;
  letter-spacing: 0.5px;
  line-height: 24px;
`;

const MobileNumberText = styled(SemiBoldText)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  align-self: flex-start;
  text-align: left;
  letter-spacing: 0.25px;
  line-height: 19.6px;
  margin-top: 0.4rem;
`;

const TimerText = styled(SubtitleText)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  align-self: flex-start;
  text-align: left;
  font-weight: 600;
  margin-left: 0.25rem;
  margin-right: 0.4rem;
`;

const InputContainer = styled.div`
  display: flex;
  align-self: stretch;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 1.625rem;
`;

const ResendContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-start;
  margin-top: 1.875rem;
  margin-bottom: 1.625rem;
`;

const ResendText = styled(SubtitleText)`
  margin-top: 0;
  font-size: 0.875rem;
  color: #585969;
`;

const StyledButtonText = styled(BoldText)`
  color: white;
`;

const StyledInputBox = styled(Input)`
  flex: 1;
  width: 3rem;
  height: 3rem;
  padding: 0;
  border: 1px solid
    ${(props) => (props.borderColor ? '#6FCF97' : '#E3E3E3')}!important;
  border-radius: 12px;
  text-align: center;
  margin-right: 1.5rem;
`;

const OtpResendContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-start;
  margin-top: 0.875rem;
`;

const SelectIcon = styled.img`
  max-width: 1.25rem;
  align-self: center;
`;

const OtpResendText = styled(ResendText)`
  color: #5cbf3d;
  margin-left: 0.625rem;
`;

class OnboardingVerifyOtp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otpValue1: '',
      otpValue2: '',
      otpValue3: '',
      otpValue4: '',
      loading: false,
      resendOtp: false,
      seconds: 59,
      disableEdit: false,
      headerText: 'Enter OTP',
      subText: ['An OTP has been sent to the', 'below number'],
      emailCode: null,
    };
    this.otpValue2 = React.createRef();
    this.handleKeyPress = this.handleKeyPress.bind(this);

    const { location } = props;
    const params = new URLSearchParams(location.search);
    if (location && location.search) {
      if (params.get('ec')) {
        this.state.emailCode = params.get('ec');
      }
    }
    const disableEdit =
      params.get('disableEdit') || location?.state?.disableEdit;
    if (disableEdit) {
      this.state.disableEdit = disableEdit;
    }
    if (location?.state && location.state?.headerText) {
      this.state.headerText = location.state.headerText;
      this.state.subText = location.state.subText;
    }
  }

  verifyOtp = () => {
    this.setState({
      loading: true,
    });
    const otp = `${this.state.otpValue1}${this.state.otpValue2}${this.state.otpValue3}${this.state.otpValue4}`;
    const { dispatch, history, location } = this.props;
    dispatch(
      verifyOtp(
        this.props.phoneNumber || this.props?.location?.state?.phone,
        otp,
        history,
        location.search,
        this.props.userInfo.ssoInfo,
        this.state.emailCode
      )
    );
  };

  handleKeyPress = (event) => {
    // console.log({ event, focus: document.activeElement.id });
    const { otpValue1, otpValue2, otpValue3, otpValue4 } = this.state;
    if (event.code === 'Backspace') {
      const currentlyFocusedElement = document.activeElement.id;
      switch (currentlyFocusedElement) {
        case 'input-1':
          if (otpValue1 === '') {
            document.querySelector('#input-1').focus();
          }
          break;
        case 'input-2':
          if (otpValue2 === '') {
            document.querySelector('#input-1').focus();
          }
          break;
        case 'input-3':
          if (otpValue3 === '') {
            document.querySelector('#input-2').focus();
          }
          break;
        case 'input-4':
          if (otpValue4 === '') {
            document.querySelector('#input-3').focus();
          }
          break;
        default:
          break;
      }
    }
    if (event.code === 'Enter') {
      if (
        !(
          otpValue1.length === 0 ||
          otpValue2.length === 0 ||
          otpValue3.length === 0 ||
          otpValue4.length === 0
        )
      ) {
        this.verifyOtp();
      }
    }
  };

  submitPhoneNumber = (id) => {
    this.setState({
      resendOtp: true,
      seconds: 59,
    });
    const { dispatch, history } = this.props;
    dispatch(
      login({
        phoneNumber: this.props.phoneNumber,
        countryCode: 91,
        channel: id === 'WHATSAPP' ? 'whatsapp' : null,
        resend: true,
        history,
      }
    )
  );
  };

  componentDidMount = () => {
    const { history, loginState, dispatch } = this.props;
    if (loginState !== 'LOGGED_IN') {
      dispatch({
        type: 'SET_SHOW_NAVIGATOR',
        payload: false,
      });
      dispatch({
        type: 'DONT_SHOW_NAVIGATOR',
        payload: true,
      });
    }
    if (loginState === 'LOGGED_IN') {
      history.replace('/home');
    } else if (loginState === 'ONE_LAST_STEP') {
      history.push('/one-last-step');
    } else if (loginState === 'SPONSOR_EMAIL') {
      history.push('/corporate-onboard');
      return false;
    } else if (loginState === 'SELECT_USER') {
      history.push('/select-user');
    } else {
      logEvent('Onboarding OTP Screen');

      document.querySelector('#input-1').focus();

      window.addEventListener('keydown', this.handleKeyPress, false);
    }
    this.myInterval = setInterval(() => {
      const { seconds } = this.state;

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
    }, 1000);
  };

  componentDidUpdate = () => {
    // otp error then change loading back to false
    if (this.state.loading && this.props.appError.hasError) {
      this.setState({
        loading: false,
      });
    }
  };

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyPress, false);
    clearInterval(this.myInterval);
  }

  render() {
    const { headerText, subText } = this.state;
    const otpValue1Link = Link.state(this, 'otpValue1')
      .pipe((val) => {
        if (val && val.toString().length === 4) {
          this.setState({
            otpValue1: val[0],
            otpValue2: val[1],
            otpValue3: val[2],
            otpValue4: val[3],
          });
          document.querySelector('#input-4').focus();
        } else {
          this.setState({
            otpValue1: val[0] ? val[0] : '',
          });
        }
      })
      .onChange((val) => {
        this.setState({
          otpValue1: val[0],
        });
        if (val.toString() === '') {
          document.querySelector('#input-1').focus();
        } else {
          document.querySelector('#input-2').focus();
        }
      });
    const otpValue2Link = Link.state(this, 'otpValue2').onChange((val, as) => {
      this.setState({
        otpValue2: val[0],
      });
      if (val.toString() === '') {
        document.querySelector('#input-1').focus();
      } else {
        document.querySelector('#input-3').focus();
      }
    });
    const otpValue3Link = Link.state(this, 'otpValue3').onChange((val, as) => {
      this.setState({
        otpValue3: val[0],
      });
      if (val.toString() === '') {
        document.querySelector('#input-2').focus();
      } else {
        document.querySelector('#input-4').focus();
      }
    });
    const otpValue4Link = Link.state(this, 'otpValue4').onChange((val, as) => {
      this.setState({
        otpValue4: val[0],
      });
      if (val.toString() === '') {
        document.querySelector('#input-3').focus();
      }
    });

    const resendOtpContainer = () => {
      let element = null;

      if (this.state.resendOtp && isCooldownActive) {
        element = (
          <OtpResendContainer>
            <SelectIcon src={greenTick} alt="Success" />
            <OtpResendText>Otp resent successfully.</OtpResendText>
          </OtpResendContainer>
        );
      }

      return element;
    };

    const isCooldownActive = this.state.seconds > 0;

    const resendOptions = [
      { id: 'SMS', label: 'SMS', icon: <SmsIcon /> },
      { id: 'WHATSAPP', label: 'WhatsApp', icon: <WhatsAppIcon /> },
    ];

    return (
      <FadeInTransition
        in={true}
        timeout={200}
        mountOnEnter
        unmountOnExit
        appear
      >
        <OuterContainer>
          <HeaderContainer>
            <ScreenIcon
              src={rightGraphic}
              alt="graphic"
              className="absolute -top-3 left-0"
              style={{ transform: 'scale(-1,-1)' }}
            />
            <ScreenIcon
              src={leftGraphic}
              alt="graphic"
              className="absolute top-16 right-0"
            />
          </HeaderContainer>
          <div className="m-auto">
            <TitleText style={{ color: '#302E6B' }}>{headerText}</TitleText>
            <SubtitleText>
              {subText.map((ele, i) => {
                return (
                  <>
                    {ele}
                    {i !== subText.length - 1 ? <br /> : ''}
                  </>
                );
              })}
            </SubtitleText>
            <MobileNumberText style={{ color: '#302E6B' }}>
              {this.props.phoneNumber}
              {!this.state.disableEdit && (
                <span className="text-primary ml-2">
                  <Goto to="/login">edit</Goto>
                </span>
              )}
            </MobileNumberText>
            <InputContainer>
              <StyledInputBox
                type="tel"
                id="input-1"
                className="visit-input"
                valueLink={otpValue1Link}
                borderColor={this.state.otpValue1.length !== 0}
              />
              <StyledInputBox
                type="tel"
                id="input-2"
                maxLength={1}
                className="visit-input"
                valueLink={otpValue2Link}
                borderColor={this.state.otpValue2.length !== 0}
              />
              <StyledInputBox
                type="tel"
                id="input-3"
                maxLength={1}
                className="visit-input"
                valueLink={otpValue3Link}
                borderColor={this.state.otpValue3.length !== 0}
              />
              <StyledInputBox
                type="tel"
                id="input-4"
                maxLength={1}
                className="visit-input"
                valueLink={otpValue4Link}
                borderColor={this.state.otpValue4.length !== 0}
              />
            </InputContainer>
            <ResendContainer>
              <ResendText>Didn’t get the OTP?</ResendText>
              {
                isCooldownActive &&
                <TimerText style={{ color: '#0F0B28' }}>
                  00:
                  {this.state.seconds > 9
                    ? this.state.seconds
                    : '0' + this.state.seconds}
                </TimerText>
              }
            </ResendContainer>
            {
              !isCooldownActive &&
              <div className="flex">
                {resendOptions.map(({ id, label, icon }) => (
                  <div
                    key={id}
                    onClick={()=>this.submitPhoneNumber(id)}
                    className={`mr-2 flex text-link font-semibold text-base cursor-pointer rounded-2xl px-3 py-1.5 border border-link items-center`}
                  >
                    <div>{icon}</div>
                    <div className="pl-1">{label}</div>
                  </div>
                ))}
              </div>
            }
            {!(
              this.state.otpValue1.length === 0 ||
              this.state.otpValue2.length === 0 ||
              this.state.otpValue3.length === 0 ||
              this.state.otpValue4.length === 0
            ) ? (
              <PrimaryButton
                onTap={this.verifyOtp}
                loading={this.state.loading}
                className="w-11/12 absolute bottom-12 left-0 right-0 text-center m-auto"
              >
                <StyledButtonText>Confirm</StyledButtonText>
              </PrimaryButton>
            ) : (
              ''
            )}

            {resendOtpContainer()}
          </div>
        </OuterContainer>
      </FadeInTransition>
    );
  }
}

const mapStateToProps = (state) => ({
  phoneNumber: state.app.loginNumber,
  countryCode: state.app.loginCountryCode,
  appError: state.app.appError,
  loginState: state.app.loginState,
  userInfo: state.user,
});

export default connect(mapStateToProps)(OnboardingVerifyOtp);
